import { ZONES } from "../data/zones.js"

const TASK_ZONE_KEYWORDS = {
  engineering: [
    "api",
    "backend",
    "bug",
    "build",
    "code",
    "debug",
    "deploy",
    "develop",
    "draw",
    "engineer",
    "fix",
    "frontend",
    "generate",
    "image",
    "implement",
    "illustration",
    "mockup",
    "picture",
    "pipeline",
    "program",
    "refactor",
    "render",
    "server",
    "test",
    "website",
  ],
  research: [
    "analyze",
    "compare",
    "data",
    "discover",
    "evaluate",
    "explore",
    "find",
    "insight",
    "investigate",
    "learn",
    "paper",
    "read",
    "research",
    "review",
    "study",
    "survey",
  ],
  comms: [
    "announce",
    "brief",
    "communicate",
    "draft",
    "email",
    "message",
    "outreach",
    "pitch",
    "post",
    "present",
    "reply",
    "report",
    "respond",
    "summarize",
    "write",
  ],
  logistics: [
    "allocate",
    "arrange",
    "budget",
    "coordinate",
    "deliver",
    "inventory",
    "manage",
    "order",
    "organize",
    "plan",
    "procure",
    "schedule",
    "ship",
    "track",
  ],
  strategy: [
    "assess",
    "competitive",
    "decide",
    "forecast",
    "goal",
    "market",
    "opportunity",
    "prioritize",
    "risk",
    "roadmap",
    "strategy",
    "vision",
  ],
}

function normalizeTaskLabel(taskLabel) {
  return String(taskLabel ?? "").trim().toLowerCase()
}

function hashString(input) {
  let hash = 0
  for (let index = 0; index < input.length; index += 1) {
    hash = ((hash * 31) + input.charCodeAt(index)) >>> 0
  }
  return hash
}

export function resolveTaskWorkZone(taskLabel) {
  const label = normalizeTaskLabel(taskLabel)
  const candidateZones = ZONES.filter((zone) => zone.id !== "life" && zone.id !== "create")
  if (candidateZones.length === 0) {
    return null
  }

  const bestZone = candidateZones
    .map((zone) => ({
      zone,
      score: (TASK_ZONE_KEYWORDS[zone.id] || []).reduce(
        (sum, keyword) => sum + (label.includes(keyword) ? 1 : 0),
        0
      ),
    }))
    .sort((left, right) => right.score - left.score)[0]

  if (bestZone?.score > 0) {
    return bestZone.zone
  }

  return candidateZones.find((zone) => zone.id === "strategy") || candidateZones[0]
}

export function resolveTaskWorkRoute(taskLabel) {
  const zone = resolveTaskWorkZone(taskLabel)
  if (!zone) {
    return {
      zoneId: null,
      targetPosition: null,
      state: "busy",
    }
  }

  const workstations = Array.isArray(zone.workstations) ? zone.workstations : []
  if (workstations.length > 0) {
    const seed = hashString(normalizeTaskLabel(taskLabel) || zone.id)
    const workstation = workstations[seed % workstations.length]
    return {
      zoneId: zone.id,
      targetPosition: [workstation[0], 0, workstation[1]],
      state: "walking",
    }
  }

  return {
    zoneId: zone.id,
    targetPosition: zone.center ? [zone.center[0], 0, zone.center[1]] : null,
    state: "busy",
  }
}
